import { COLORS } from 'helpers/globals'

const sceneImage = {
  width: '100%',
  height: '100%',
  border: `1px solid ${COLORS.quaternary}`,
  verticalAlign: 'middle'
}

const sceneThumbnail = {
  padding: '0 .5rem',
  flex: '0 0 60vw',
  '& img': sceneImage,
  '&:first-of-type': {
    paddingLeft: '1rem'
  },
  '&:last-of-type': {
    paddingRight: '1rem',
    height: '100%'
  }
}

export default {
  container: {
    overflow: 'auto',
    background: '#eeeeee',
    minHeight: 0,
    width: '100%',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    padding: '1rem 0',
    flex: 1
  },
  sceneThumbnail,
  sceneThumbnailCurrent: {
    ...sceneThumbnail,
    '& img': {
      ...sceneImage,
      border: `8px solid ${COLORS.primary}`
    }
  },
  blank: {
    height: '100%',
    border: `1px solid ${COLORS.quaternary}`,
    color: COLORS.secondary,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
    fontSize: '2rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/SimulatedView/SceneSelector/style.js